export default __webpack_public_path__ + "static/Economic Model Whitepaper - German-16ca46433d83221bb6a7978f2d845e1a.pdf";